    import LockerMonitoringApp from './components/LockerMonitoringApp';

    function App() {
      return (
        <div className="App">
          <LockerMonitoringApp />
        </div>
      );
    }

    export default App;